module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-noneheader"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(this.$route.query.customerId != null) ? _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("客户管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/customer/customerEmpList'
      }
    }
  }, [_vm._v("我的客户")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/memo/systemMemoList',
        query: {
          customerId: this.$route.query.customerId
        }
      }
    }
  }, [_vm._v("服务提醒")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("录入")])], 1) : _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("客户管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/memo/systemMemoList'
      }
    }
  }, [_vm._v("服务提醒")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("录入")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "form-default",
    attrs: {
      "model": _vm.vo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户",
      "prop": "customerInfo"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请选择客户",
      "readonly": true
    },
    model: {
      value: (_vm.vo.customerInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.vo.customerInfo, "name", $$v)
      },
      expression: "vo.customerInfo.name"
    }
  }, [(!_vm.customerId) ? [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handlePopRefBtnClick
    },
    slot: "append"
  })] : _vm._e()], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户",
      "prop": "toUser"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.vo.toUser.name),
      callback: function($$v) {
        _vm.$set(_vm.vo.toUser, "name", $$v)
      },
      expression: "vo.toUser.name"
    }
  })], 1), _vm._v(" "), _c('el-tabs', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "tab-position": "left"
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "id": "dateRange",
      "label": "日期范围"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "日期范围",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.vo.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.vo, "dateRange", $$v)
      },
      expression: "vo.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "id": "loop",
      "label": "周期循环"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "align": "right",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.vo.beginAt),
      callback: function($$v) {
        _vm.$set(_vm.vo, "beginAt", $$v)
      },
      expression: "vo.beginAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复间隔"
    }
  }, [_c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输入重复间隔（天数）"
    },
    model: {
      value: (_vm.vo.loopInterval),
      callback: function($$v) {
        _vm.$set(_vm.vo, "loopInterval", _vm._n($$v))
      },
      expression: "vo.loopInterval"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vo.remark),
      callback: function($$v) {
        _vm.$set(_vm.vo, "remark", $$v)
      },
      expression: "vo.remark"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "1rem 0rem"
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择用户",
      "visible": _vm.popRefCustomerInfo
    },
    on: {
      "update:visible": function($event) {
        _vm.popRefCustomerInfo = $event
      }
    }
  }, [_c('div', {
    staticClass: "search-div"
  }, [_c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输入客户姓名"
    },
    model: {
      value: (_vm.infoName),
      callback: function($$v) {
        _vm.infoName = $$v
      },
      expression: "infoName"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输入客户编号"
    },
    model: {
      value: (_vm.infoCustomerNum),
      callback: function($$v) {
        _vm.infoCustomerNum = $$v
      },
      expression: "infoCustomerNum"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "input-size-200 input-margin-right",
    attrs: {
      "placeholder": "请输入系统用户昵称"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-pull-right",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.infoListSearch()
      }
    }
  }, [_vm._v("搜索\n        ")]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dt.data,
      "stripe": true,
      "border": "",
      "highlight-current-row": "",
      "size": "mini",
      "size": _vm.dt.size
    },
    on: {
      "sort-change": _vm.dt.handleSortChange,
      "selection-change": _vm.dt.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "id",
      "label": "ID",
      "min-width": "5%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "名称",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerNum",
      "label": "客户编号",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "user.name",
      "label": "系统用户昵称",
      "min-width": "10%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleInfoChoice(scope.$index, scope.row)
            }
          }
        }, [_vm._v("选择\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.dt.currentPage,
      "page-sizes": _vm.dt.pageSizes,
      "page-size": _vm.dt.pageSize,
      "layout": _vm.dt.layout,
      "total": _vm.dt.totalElements
    },
    on: {
      "size-change": _vm.dt.handleSizeChange,
      "current-change": _vm.dt.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21127a5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/memo/SystemMemoModify.vue
// module id = 447
// module chunks = 2